import { DappsTab, KybTab, MembersTab, OverviewTab } from './tabs';
import type { SuperPublisherTabDefinition } from './types';

export const superPublisherTabs: SuperPublisherTabDefinition[] = [
  { key: 'overview', label: 'Overview', component: OverviewTab },
  { key: 'dapps', label: 'Dapps', component: DappsTab },
  { key: 'members', label: 'Members', component: MembersTab },
  { key: 'kyb', label: 'KYB', component: KybTab },
];
